import { createSelector } from "reselect";

const featureSelector = ({ loader }) => loader;

export const getLoader = createSelector(featureSelector, (loader) => loader);
